import { fetcher } from './../fetcher';
import { createPaymentInfo, Url } from './../common';
import store from './../store';
export var processFreePayment = function (paymentDetails, provider) {
    var data = createPaymentInfo(paymentDetails, provider);
    data.payment_provider = provider;
    data.uuid = window.getUuid();
    data.customerUuid = window.getCustomerUuid();
    data.checkoutOffer = window.backEndVars.checkoutOffer;
    data.utmParams = store.getMarketingInfo('lastUtmParams');
    var url = new Url().build('products', 'payments', 'free-product', 'request');
    var purchase = data.purchase;
    fetcher
        .post(url, {
        uuid: window.getUuid(),
        customerUuid: window.getCustomerUuid(),
        type: window.backEndVars.type,
        purchasableCategory: paymentDetails.category,
        purchasableType: paymentDetails.type,
        checkoutOffer: window.backEndVars.checkoutOffer,
        provider: provider,
        paymentMethod: provider,
        purchase: purchase,
    })
        .catch(function (err) {
        window.redirectToFinalPage();
    });
};
